import { Box, Grid, Heading, Stack } from "@chakra-ui/react";
import React from "react";
import TimelineItem from "./TimelineItem";

const items = [
    {
        leftTop: '7+ years',
        leftBottom: 'consultant',
        right: [{ title: 'Another Tomorrow' }, { title: 'Netlight' }, { title: 'Valtech' }]
    },
    {
        leftTop: '5 years',
        leftBottom: 'education',
        right: [{ subTitle: 'Linköping University', title: 'Master of Science in Media Technology and Engineering' }, { subTitle: 'École polytechnique fédérale de Lausanne (EPFL)', title: 'Computer Science' }]
    },
    {
        leftTop: '9+',
        leftBottom: 'dev skills',
        right: [
            { subTitle: 'Programming', title: 'React, Node.js, SASS' },
            { subTitle: 'CMS', title: 'Contentful, EpiServer, Sanity' },
            { subTitle: 'Tools', title: 'Git, AWS, Google Cloud, Google API' }
        ],
    },
    {
        leftTop: '6+',
        leftBottom: 'UX skills',
        right: [
            { subTitle: 'Skills', title: 'Wireframing, User testing, Interview techniques, Ideation' },
            { subTitle: 'Tools', title: 'Figma, Miro' }
        ],
    }
]

const Timeline = () => (
    <Stack gap={4} p="5">
        <Heading as="h2" fontSize={['4xl', '5xl']} textAlign="center">The Hard Stuff</Heading>
        <Box>
            <Grid templateColumns={["0.3fr 40px 1fr","1fr 80px 1fr"]} alignItems={"center"} gap={["5", "7"]}>
                {items.map((item, index) => <TimelineItem item={item} isFirst={index === 0} isLast={index === items.length - 1} />)}
            </Grid>
        </Box>
    </Stack>
)

export default Timeline;